import {format} from '@yandex-delivery/core/phones/selectors'
import {logError} from '@yandex-delivery/modules/rum'

import {config} from '../config'

const baseFormat = format(config.rules || [])

export function formatPhone(phone: string): string {
  if (phone.includes('*')) {
    return formatMaskedPhone(phone)
  }

  return baseFormat(phone)
}

/**
 * Функция для форматирования маскированных номеров телефонов с сохранением звездочек
 * @param phone - Номер телефона, который содержит звездочки вместо скрытых цифр
 * @returns Отформатированный номер телефона с сохранением маскировки
 */
function formatMaskedPhone(phone: string): string {
  // TODO: CARGODEV-74584 Сейчас форматирование маскированных телефонов сделано только для ру/кз номеров
  // нужно будет убрать это условие и поправить функцию при необходимости
  if (!phone.startsWith('+7')) {
    return phone
  }

  // Для маскированных телефонов нам нужно сохранить звездочки в их позициях:
  // 1. Извлечь все цифры и звездочки по порядку
  // 2. Создать шаблон, отформатировав фиктивный номер той же длины
  // 3. Заменить цифры в шаблоне на оригинальные цифры/звездочки

  try {
    // Извлекаем только цифры и звездочки, сохраняя порядок
    const digitsAndAsterisks = phone.replace(/[^\d*]/g, '') // например, '7********98'

    // выбираем фиктивный символ-заполнитель
    let dummySymbol: string
    if (phone[0] === '+') {
      dummySymbol = phone[1].match(/\d/) ? phone[1] : '1'
    } else {
      dummySymbol = '1'
    }

    // Создаем фиктивную строку той же длины, используя фиктивный символ
    const dummy = dummySymbol.repeat(digitsAndAsterisks.length) // например, '77777777777'

    // Добавляем знак плюс, чтобы сделать его действительным телефоном для форматирования
    const dummyPhone = '+' + dummy // например, '+77777777777'

    // Форматируем фиктивный телефон, чтобы получить шаблон
    const formattedTemplate = baseFormat(dummyPhone) // например, '+7 (777) 777-77-77'

    // Теперь заменяем фиктивные символы в отформатированном шаблоне на оригинальные символы
    let result = ''
    let sourceIndex = 0

    for (let i = 0; i < formattedTemplate.length; i++) {
      const char = formattedTemplate[i]
      if (char === dummySymbol) {
        // Заменяем на соответствующий символ из нашего источника
        if (sourceIndex < digitsAndAsterisks.length) {
          result += digitsAndAsterisks[sourceIndex]
          sourceIndex++
        } else {
          result += char
        }
      } else {
        // Сохраняем символы форматирования (пробелы, скобки и т.д.)
        result += char
      }
    }

    return result
  } catch (error) {
    console.error(error)
    logError(
      {
        source: 'client',
        additional: {
          phone,
        },
      },
      error,
    )

    // В случае ошибки возвращаем исходный номер телефона со звездочками
    return phone
  }
}
